'use strict';

angular.module('client.services').factory('googleService', ['$resource', '$q', '$location', 'CourseFactory', '$log', '$window',
  'ModalService', 'User', 'api_server',
  function ($resource, $q, $location, CourseFactory, $log, $window, ModalService, User, api_server) {

    var imsResource = $resource(api_server + '/users/:id/ims', {id: '@id'},
      {
        'get': {method: 'GET', isArray: true}
      });

    function getIms(id) {
      return imsResource.get({id: id}).$promise;
    }

    var scopePermission = $resource(api_server + '/auth/google/class_scopes', {},
      {
        'get': {method: 'GET', isArray: false}
      });

    function hasFullClassroomPermission(user) {
      if (!user.google_user) {
        return $q.when({hasPermission: true});
      }
      return scopePermission.get().$promise.then(function(response) {
        return response;
      });
    }

    function checkAndRequestClassroomPermission(user, options) {
      const permissionOptions = options || {};
      return hasFullClassroomPermission(user).then(function(permission) {
        if (permission.hasPermission) {
          return true;
        }

        ModalService.show({
          title: 'Google Classroom Scopes',
          message: permissionOptions.message,
          buttons: [
            {
              title: 'Yes',
              click: 'requestGooglePermissions(); $hide();'
            },
            {
              title: 'No',
              click: 'declineGooglePermissions(); $hide();'
            }
          ],
          requestGooglePermissions: function() {
            if (permissionOptions.beforeRedirect) {
              permissionOptions.beforeRedirect();
            }
            $window.location.href = permission.url;
          },
          declineGooglePermissions: function() {
            if (permissionOptions.onDecline) {
              permissionOptions.onDecline();
            }
          }
        });
        return false;
      });
    }

    var coursesResource = $resource(api_server + '/ims/courses/list', {ims_id: '@ims_id'},
      {
        'get': {method: 'GET', isArray: true}
      });

    function getCourses(ims_id) {
      return coursesResource.get({ims_id: ims_id}).$promise;
    }

    var importResource = $resource(api_server + '/ims/courses/import/:id', {id: '@id'},
      {
        'post': {method: 'POST'}
      });

    function importCourse(id, params) {
      return importResource.post({id: id}, params).$promise;
    }

    var syncResource = $resource(api_server + '/ims/courses/sync', {ims_id: '@ims_id'},
      {
        'post': {method: 'POST'}
      });

    function syncCourse(ims_id, id) {
      return syncResource.post({ims_id: ims_id}, {cid: id}).$promise;
    }

    var assignmentResource = $resource(api_server + '/ims/assignment/:experience_id', {
        experience_id: '@experience_id',
        ims_id: '@ims_id'
      },
      {
        'post': {method: 'POST'}
      });

    function postAssignment(ims_id, experience_id) {
      return assignmentResource.post({experience_id: experience_id, ims_id: ims_id}).$promise;
    }

    function normalizeGoogleCourseId(courseId) {
      if (typeof courseId !== 'string') {
        return null;
      }

      const normalizedCourseId = String(courseId).trim();
      return normalizedCourseId || null;
    }

    function getAvailableCourses(user) {
      var googleClasses = {
        courses: [],
        has_courses: false,
        lms_id: 0
      };

      // if this user is NOT a google user then immediately return an empty list
      if (!user.google_user) {
        return $q.when(googleClasses);
      }

      return getIms(user.id).then(function (response) {
        // If the current user is not google user then return empty list
        if (!response || !response.length) {
          return googleClasses;
        }

        var imsUser = response.find(function (res) {
          return res.int_id === -1;
        });
        if (!imsUser) {
          return googleClasses;
        }

        googleClasses.lms_id = imsUser.int_id;

        return getCourses(imsUser.int_id).then(function (googleCourses) {
          // If google does not return a valid list of classes then just resolve to an empty list
          if (!googleCourses || !googleCourses.length) {
            return googleClasses;
          }

          const validGoogleCourses = googleCourses.filter(function (googleCourse) {
            const googleCourseId = normalizeGoogleCourseId(googleCourse.id);
            if (googleCourseId === null) {
              $log.error("Google Classroom course is missing a valid ID");
              return false;
            }
            return true;
          });
          googleClasses.has_courses = validGoogleCourses.length > 0;

          // Now lookup this teachers existing classes so we can remove duplicates
          var params = {teacher_user_id: User.getId()};
          return CourseFactory.list(params).then(function (courses) {
            const importedGoogleCourseIds = [];

            courses.forEach(function (course) {
              try {
                const settings = angular.fromJson(course.settings) || {};
                if (!settings.ims || settings.ims.ims_id !== -1) {
                  return;
                }

                const importedCourseId = normalizeGoogleCourseId(settings.ims.classroom);
                if (importedCourseId === null) {
                  $log.error("Google-linked Exploros class is missing a valid Classroom ID:", course.cid);
                  return;
                }
                importedGoogleCourseIds.push(importedCourseId);
              }
              catch (e) {
                $log.error(e.message);
              }
            });

            // Remove any google classes that have already been added
            googleClasses.courses = validGoogleCourses.filter(function (googleCourse) {
              const googleCourseId = normalizeGoogleCourseId(googleCourse.id);
              return !importedGoogleCourseIds.includes(googleCourseId);
            });
            return googleClasses;
          }, function (error) {
            $log.error("classroom API error:", error);
            $q.reject(error);
          });
        });
      })
        .catch(function (error) {
          $log.error("get classroom API error:", error);
          $q.resolve(googleClasses);
        });
    }

    var linkResource = $resource(api_server + '/ims/courses/link', {ims_id: '@ims_id'},
      {
        'post': {method: 'POST'}
      });

    function linkCourse(user, cid, className, courseId, sectionId, settings) {
      return getIms(user.id).then(function (response) {
        if (!response || !response.length) {
          return null;
        }

        var imsUser = response.find(function (res) {
          return Number(res.int_id) === -1;
        });

        if (!imsUser) {
          return null;
        }
      return linkResource.post({ims_id: imsUser.int_id}, {cid: cid, className: className, courseId: courseId, sectionId: sectionId, settings: settings}).$promise;
      });
    }

    return {
      hasFullClassroomPermission: hasFullClassroomPermission,
      checkAndRequestClassroomPermission: checkAndRequestClassroomPermission,
      importCourse: importCourse,
      syncCourse: syncCourse,
      postAssignment: postAssignment,
      getAvailableCourses: getAvailableCourses,
      linkCourse: linkCourse
    };
  }]);
